module.exports = __webpack_public_path__ + "static/media/selfie-face-blur.71a47b07.svg";